/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                        from '@material-ui/core'

import HistoryCitationCreateComponent  from './HistoryCitationCreateComponent'
import HistoryReadComponent            from './HistoryReadComponent'
import PhotoSearchComponent            from './PhotoSearchComponent'

import {
   CLIENT_PUBLIC_TOKEN,
   historyRadioOptions
}                                      from '../config'

import { node_server }                 from '../Helpers'
import PropTypes                       from 'prop-types'

const HistoryCitationComponent = ({ action }) => {

   useEffect( () => {
console.log('HistoryCitationComponent useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'getCitations')
   }, [])

   const [ displayCitations,  setDisplayCitations  ]  =  useState([])

   return (
      <Box style={{ marginTop: '6rem' }} >
         <Grid>
            <Typography>
               History Citation Component action is { action }
            </Typography>
            { action === 'create a history citation' ? <HistoryCitationCreateComponent /> : null }
         </Grid>
      </Box>
   )
}

export default HistoryCitationComponent

HistoryCitationComponent.propTypes = {
   action:   PropTypes.string
}